import { FunctionComponent, useState } from 'react'
import { Switch, Route } from 'react-router-dom'
import {
  ChecklistCategoryAPIResponse,
  RFPSortBy,
  SiteRFPPhaseAPIResponse,
} from '@black-bear-energy/black-bear-energy-common'
import { rucksack, Box, Container } from '@black-bear-energy/rucksack'
import {
  enableChecklistCategories,
  enableSideNavigation,
} from '../featureFlags'
import { useRFPDocumentSummaries } from '../api/hooks/useRFPDocumentSummaries'
import { CustomerRFPList } from '../components/DocumentExchange/CustomerRFPList'
import { CustomerRFPDashboard } from '../components/DocumentExchange/CustomerRFPDashboard'
import { SiteRFPDashboard } from '../components/DocumentExchange/SiteRFPDashboard'
import { SelectChecklistPage } from '../components/DocumentExchange/SelectChecklistPage'
import { SiteRFPChecklistPage } from '../components/DocumentExchange/SiteRFPChecklistPage'
import { SiteRFPDocumentExchangeLayout } from '../components/DocumentExchange/SiteRFPDocumentExchangeLayout'

export const DocumentExchange: FunctionComponent = () => {
  const [search, setSearch] = useState('')
  const [requiredMissing, setRequiredMissing] = useState(false)
  const [reviewMissing, setReviewMissing] = useState(false)
  const [phase, setPhase] = useState<SiteRFPPhaseAPIResponse[]>([])
  const [sortBy, setSortBy] = useState(RFPSortBy.RFPName)
  const [sortAsc, setSortAsc] = useState(true)
  const [page, setPage] = useState(1)
  const { isPending, data } = useRFPDocumentSummaries(
    search,
    requiredMissing,
    reviewMissing,
    phase,
    sortBy,
    sortAsc,
    page
  )
  const { records: rfpDocumentSummaries, pagination } = data ?? {}
  const totalPages = pagination?.totalPages ?? 1

  function onFilterChange() {
    setPage(1)
  }

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        ...(!enableSideNavigation && { pt: 4, px: 8 }),
        backgroundColor: rucksack.palette.background.page,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Switch>
          <Route exact path="/document-exchange">
            <CustomerRFPList
              rfpDocumentSummaries={rfpDocumentSummaries}
              isPending={isPending}
              search={search}
              setSearch={(search: string) => {
                setSearch(search)
                onFilterChange()
              }}
              requiredMissing={requiredMissing}
              setRequiredMissing={(requiredMissing: boolean) => {
                setRequiredMissing(requiredMissing)
                onFilterChange()
              }}
              reviewMissing={reviewMissing}
              setReviewMissing={(reviewMissing: boolean) => {
                setReviewMissing(reviewMissing)
                onFilterChange()
              }}
              phase={phase}
              setPhase={(phase: SiteRFPPhaseAPIResponse[]) => {
                setPhase(phase)
                onFilterChange()
              }}
              sortBy={sortBy}
              setSortBy={setSortBy}
              sortAsc={sortAsc}
              setSortAsc={setSortAsc}
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          </Route>
          <Route exact path="/document-exchange/projects/:customerRFPId">
            <CustomerRFPDashboard />
          </Route>
          {enableChecklistCategories ? (
            <Route path="/document-exchange/projects/:customerRFPId/sites/:siteRFPId">
              <SiteRFPDocumentExchangeLayout>
                <Switch>
                  <Route path="/document-exchange/projects/:customerRFPId/sites/:siteRFPId/contracts">
                    <SiteRFPChecklistPage
                      category={ChecklistCategoryAPIResponse.Contracts}
                    />
                  </Route>
                  <Route path="/document-exchange/projects/:customerRFPId/sites/:siteRFPId/construction">
                    <SiteRFPChecklistPage
                      category={ChecklistCategoryAPIResponse.Construction}
                    />
                  </Route>
                  <Route
                    exact
                    path="/document-exchange/projects/:customerRFPId/sites/:siteRFPId"
                  >
                    <SelectChecklistPage />
                  </Route>
                </Switch>
              </SiteRFPDocumentExchangeLayout>
            </Route>
          ) : (
            <Route
              exact
              path="/document-exchange/projects/:customerRFPId/sites/:siteRFPId"
            >
              <SiteRFPDashboard />
            </Route>
          )}
        </Switch>
      </Box>
      {!enableSideNavigation && <Box sx={{ height: '8rem' }} />}
    </Container>
  )
}
